// @ts-nocheck
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { VerticalTabs } from 'sonata-react-components';

import { ControlPanelStyle } from './controlPanel.style';
import { MainSettingsPanel } from './MainSettingsPanel';

type Props = {
  className: string;
  isFootfallAttrMap?: boolean;
};

export function ControlPanel({ className, isFootfallAttrMap = false }: Props) {
  const { formatMessage } = useIntl();
  const tabsConfig = useMemo(
    () => [
      {
        Component: MainSettingsPanel,
        componentConfig: {
          isFootfallAttrMap
        },
        description: formatMessage({
          defaultMessage: 'Main settings',
          id: 'reporting.map.controlPanel.mainSettings.title'
        }),
        icon: 'fal fa-cog',
        id: 'mainSettings',
        name: formatMessage({
          defaultMessage: 'Main settings',
          id: 'reporting.map.controlPanel.mainSettings.title'
        }),
        theme: 'light',
        visible: true
      }
    ],
    []
  );

  return (
    <ControlPanelStyle className={`controlPanel ${className}`}>
      <VerticalTabs customClass="mapControlPanel" tabsConfig={tabsConfig} />
    </ControlPanelStyle>
  );
}
